import Client from '../client';
import { AxiosResponse } from 'axios';
import BaseService from '../baseService/baseService';

const MultiplicadorPddIntermediariasService = 
{
    deletarExcelParametros(fileRequest: any)
    {
        return BaseService.conectarEndpoint(fileRequest,'multiplicador-pdd-intermediarias/excel/deletar', 'excelPddIntermediariasDeletar')
    },
    enviarExcelParametros(fileRequest: any)
    {
        return BaseService.conectarEndpoint(fileRequest, 'multiplicador-pdd-intermediarias/excel', 'excelPddIntermediarias');
    },
    obterExcel(): Promise<void | AxiosResponse<any>> 
    {
        return Client.getBlob('multiplicador-pdd-intermediarias/excel');
    },
    enviarParametrosAoEventGrid(): Promise<void | AxiosResponse<any>> 
    {
        return Client.post('multiplicador-pdd-intermediarias/eventGrid', {});
    }
}

export default MultiplicadorPddIntermediariasService;